export default __webpack_public_path__ + "static/icon_goldin_light-909fca3075dd6e231bc2167dfada7562.svg";